/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseDocumentDataExtractionHealthcare = dynamic(
  () => import('../tasks/TaskResponseDocumentDataExtractionHealthcare'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

// export const instruction =
//   'Identify patient and billing information in claims documents at 99% accuracy.';

export const responseCode = `{
  "response": {
    "annotations": [
      {
        "label": "ProviderName",
        "value": "Lucy Hall, M.D.",
        "box": {
          "x": 100,
          "y": 200,
          "width": 64,
          "height": 32
        }
      }
      ...
    ]
  },
  "task_id": "5795c68afce306120434be64",
  "task": { ... }
}`;

export const code = `client.createDataExtractionTask({
  callback_url: 'http://www.example.com/callback',
  instruction: 'Identify patient and billing information.',
  params: {
      attachments: [
        {
          type: 'pdf'
          content: 'claims_document.pdf'
        }
      ],
      labels: ['ProviderName', 'Diagnosis Code', ...],
      boundingboxes: true,
  }
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => <TaskResponseDocumentDataExtractionHealthcare howItWorks />;

export const result = <TaskResponseDocumentDataExtractionHealthcare animate howItWorks />;
